import { Subject } from 'rxjs';
import { takeUntil } from 'rxjs/operators';

import {
  ChangeDetectorRef,
  Component,
  EventEmitter,
  Input,
  OnDestroy,
  OnInit,
  Output,
} from '@angular/core';

import { SnTag } from '@lib/api/entities';
import { SnTagsAPI } from '@lib/api/services';

@Component({
  selector: 'fs-tags-resource',
  templateUrl: './tags-resource.component.html',
  styleUrls: ['./tags-resource.component.scss'],
})
export class TagsResourceComponent implements OnInit, OnDestroy {
  @Input() public resources: any[];

  @Input() public removable: boolean;

  @Output() public readonly loadedTags = new EventEmitter();

  @Input()
  public tags: SnTag[];

  public isLoading: boolean = false;
  private readonly _destroy$ = new Subject();

  constructor(private readonly _cd: ChangeDetectorRef, private readonly _tagsAPI: SnTagsAPI) {}

  public ngOnInit(): void {
    this._loadCameraTags();
    this._loadLocationTags();
    this._cd.detectChanges();
  }

  public ngOnDestroy(): void {
    this._destroy$.next();
    this._destroy$.complete();
  }

  private _loadCameraTags(): void {
    if (!this.resources[0]?.tagRecords_Tag_Id_In?.length) {
      return;
    }
    this.isLoading = true;
    this.resources[0].tagRecords_Tag_Id_In.forEach((tagID) => {
      this._tagsAPI
        .getTag(tagID)
        .pipe(takeUntil(this._destroy$))
        .subscribe({
          next: (res) => {
            const index = this.tags.findIndex((tag) => {
              return tag.id === res.id;
            });
            if (index === -1) {
              this.tags.push(res);
            }
            this._cd.detectChanges();
            this.isLoading = false;
          },
          error: () => {
            this.isLoading = false;
          },
        });
    });
    this._cd.detectChanges();
  }

  private _loadLocationTags(): void {
    if (!this.resources[0]?.location_TagRecords_Tag_Id_In?.length) {
      return;
    }
    this.isLoading = true;
    this.resources[0].location_TagRecords_Tag_Id_In.forEach((tagID) => {
      this._tagsAPI
        .getTag(tagID)
        .pipe(takeUntil(this._destroy$))
        .subscribe({
          next: (res) => {
            const index = this.tags.findIndex((tag) => {
              return tag.id === res.id;
            });
            if (index === -1) {
              this.tags.push(res);
            }
            this._cd.detectChanges();
            this.isLoading = false;
          },
          error: () => {
            this.isLoading = false;
          },
        });
    });
    this._cd.detectChanges();
  }
}
